import { ContractType, Customer } from './../../js/constants';
import AIRA_contract from './aira-contract';
import EAON_card_contract from './aeon-card-contract';
import EAON_loan_contract from './aeon-loan-contract';
import EAON_leasing_contract from './aeon-leasing-contract';
import rabbitContract from './rabbit-contract';
import amcContract from './amc-contract';
import mddContract from './mdd-contract';


export function getUI(customerId, contractTypeId) {
    if (contractTypeId.toLowerCase() === ContractType.AIRA.toLowerCase()) {
        return AIRA_contract();
    }
    if (contractTypeId.toLowerCase() === ContractType.AEON_CARD.toLowerCase()) {
        return EAON_card_contract();
    }
    if (contractTypeId.toLowerCase() === ContractType.AEON_LOAN.toLowerCase()) {
        return EAON_loan_contract();
    }
    if (contractTypeId.toLowerCase() === ContractType.AEON_LEASING.toLowerCase()) {
        return EAON_leasing_contract();
    }
    if (contractTypeId.toLowerCase() === ContractType.RABBIT_CASH.toLowerCase()) {
        return rabbitContract();
    }
    if (contractTypeId.toLowerCase() === ContractType.RABBIT_INSTALLMENT.toLowerCase()) {
        return rabbitContract();
    }
    if (contractTypeId.toLowerCase() === ContractType.RABBIT_BENEFIT.toLowerCase()) {
        return rabbitContract();
    }
    if (contractTypeId.toLowerCase() === ContractType.RABBIT_BENEFIT_SPECIAL.toLowerCase()) {
        return rabbitContract();
    }
    if (customerId.toLowerCase() === Customer.AMC_ID.toLowerCase()) {
        return amcContract();
    }
    if (customerId.toLowerCase() === Customer.MDD_ID.toLowerCase()) {
        return mddContract();
    }
}
